import styled from 'styled-components';

export default styled.p`
  display: ${props => props.showError ? 'inherit' : 'none'};
  width: 100%;
  border: none;
  color: #FF5D4C;
  font-size: 1.2rem;
  margin: 1rem 0.5rem;
`;
